import axios from 'axios';

const url = 'https://api.ipify.org/?format=json';

export const getIpAddress = async () => {
    const res = await axios.get(url);
    return res.data.ip
}